import { Grid } from "../../../features/flyer-template/types/grid/grid.interface";
import { action, ActionType } from "typesafe-actions";
import { FlyerTemplate } from "../../../features/flyer-template/types/flyer-template/flyer-template.interface";
import { Nullable } from "../../../../../types/common";
import { Canvas } from "../../../features/flyer-template/types/canvas/canvas.interface";
import { XyCoordinates } from "../../../features/flyer-template/types/xy-coordinates.interface";
import { GridLine } from "../../../features/flyer-template/types/grid/grid-line/grid-line.interface";
import { GridCellSelectionRange } from "../types/grid-cell-selection-range/grid-cell-selection-range.interface";
import { Range } from "../../../../../types/range/range";
import { FlyerTemplatePosition } from "../../../features/flyer-template/types/flyer-template-position/flyer-template-position.interface";
import { FlyerTemplatePositionEditForm } from "../../../features/flyer-template/types/flyer-template-position-edit-form/flyer-template-position-edit-form.interface";
import { IError } from "../../../../../redux/actions/errorHandlingAction";

export enum FlyerTemplateCreatorActions {
  SetCanvas = "FlyerTemplateCreator/SetCanvas",
  UpdateCanvas = "FlyerTemplateCreator/UpdateCanvas",
  CreateGrid = "FlyerTemplateCreator/CreateGrid",
  SetGrid = "FlyerTemplateCreator/SetGrid",
  SetTemplate = "FlyerTemplateCreator/SetTemplate",

  SetTemplateName = "FlyerTemplateCreator/SeTemplateName",

  MoveGridLine = "FlyerTemplateCreator/RepositionGridLine",

  AddRow = "FlyerTemplateCreator/AddRow",
  RemoveRow = "FlyerTemplateCreator/RemoveRow",
  SetRows = "FlyerTemplateCreator/SetRows",

  AddColumn = "FlyerTemplate/AddColumn",
  RemoveColumn = "FlyerTemplate/RemoveColumn",
  SetColumns = "FlyerTemplate/SetColumns",

  MovePosition = "FlyerTemplateCreator/MovePosition",

  CreatePosition = "FlyerTemplateCreator/CreatePosition",
  RemovePosition = "FlyerTemplateCreator/RemovePosition",

  SetAspectRatio = "FlyerTemplateCreator/SetAspectRatio",

  Save = "FlyerTemplateCreator/Save",
  SaveFailure = "FlyerTemplateCreator/SaveFailure",
  SaveSuccess = "FlyerTemplateCreator/SaveSuccess",

  Reset = "FlyerTemplateCreator/Reset",

  EditPosition = "FlyerTemplateCreator/EditPosition",
  SetEditingPosition = "FlyerTemplateCreator/SetEditingPosition",
  SavePositionDetails = "FlyerTemplateCreator/SavePositionDetails",
  SavePositionDetailsSuccess = "FlyerTemplateCreator/SavePositionDetailsSuccess",
}

export const setCanvas = (canvas: Canvas) => action(FlyerTemplateCreatorActions.SetCanvas, canvas);
export const updateCanvas = (canvas: Canvas) =>
  action(FlyerTemplateCreatorActions.UpdateCanvas, canvas);
export const createGrid = () => action(FlyerTemplateCreatorActions.CreateGrid);
export const setGrid = (grid: Nullable<Grid>) => action(FlyerTemplateCreatorActions.SetGrid, grid);
export const setTemplate = (template: FlyerTemplate) =>
  action(FlyerTemplateCreatorActions.SetTemplate, template);
export const moveGridLine = (line: GridLine, position: XyCoordinates) =>
  action(FlyerTemplateCreatorActions.MoveGridLine, { line, position });

export const addRow = () => action(FlyerTemplateCreatorActions.AddRow);
export const removeRow = () => action(FlyerTemplateCreatorActions.RemoveRow);
export const setRows = (rows: number) => action(FlyerTemplateCreatorActions.SetRows, rows);

export const addColumn = () => action(FlyerTemplateCreatorActions.AddColumn);
export const removeColumn = () => action(FlyerTemplateCreatorActions.RemoveColumn);
export const setColumns = (columns: number) =>
  action(FlyerTemplateCreatorActions.SetColumns, columns);

export const createPosition = (selection: GridCellSelectionRange) =>
  action(FlyerTemplateCreatorActions.CreatePosition, selection);
export const removePosition = (positionId: number) =>
  action(FlyerTemplateCreatorActions.RemovePosition, positionId);

export const movePosition = (positionIndex: number, rows: Range, columns: Range) =>
  action(FlyerTemplateCreatorActions.MovePosition, { positionIndex, rows, columns });

export const setTemplateName = (name: string) =>
  action(FlyerTemplateCreatorActions.SetTemplateName, name);

export const setAspectRatio = (ratio: number, screenWidth: number, screenHeight: number) =>
  action(FlyerTemplateCreatorActions.SetAspectRatio, { ratio, screenWidth, screenHeight });

export const save = () => action(FlyerTemplateCreatorActions.Save);
export const saveFailure = (error: IError) =>
  action(FlyerTemplateCreatorActions.SaveFailure, error);
export const saveSuccess = (template: FlyerTemplate) =>
  action(FlyerTemplateCreatorActions.SaveSuccess, template);

export const reset = () => action(FlyerTemplateCreatorActions.Reset);

export const editPosition = (positionId: string) =>
  action(FlyerTemplateCreatorActions.EditPosition, positionId);
export const setEditingPosition = (position: Nullable<FlyerTemplatePosition>) =>
  action(FlyerTemplateCreatorActions.SetEditingPosition, position);
export const savePositionDetails = (form: FlyerTemplatePositionEditForm) =>
  action(FlyerTemplateCreatorActions.SavePositionDetails, form);
export const savePositionDetailsSuccess = (template: FlyerTemplate) =>
  action(FlyerTemplateCreatorActions.SavePositionDetailsSuccess, template);

const actionCreators = {
  setCanvas,
  updateCanvas,
  setGrid,
  setTemplate,
  addRow,
  removeRow,
  setRows,
  addColumn,
  removeColumn,
  setColumns,
  moveGridLine,
  createPosition,
  removePosition,
  setTemplateName,
  setAspectRatio,
  save,
  saveFailure,
  saveSuccess,
  reset,
  editPosition,
  setEditingPosition,
  savePositionDetails,
  savePositionDetailsSuccess,
  movePosition,
};

export type FlyerTemplateCreatorActionsType = ActionType<typeof actionCreators>;
